import { render, staticRenderFns } from "./EqCriterion.vue?vue&type=template&id=64f97a82&"
import script from "./EqCriterion.vue?vue&type=script&lang=js&"
export * from "./EqCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports